var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feed-new-items-badge"},[_c('base-button',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n    "+_vm._s(_vm.$tc("feed.items.newItem", _vm.number))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }